/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input, OnInit } from '@angular/core';
import { PredefinedColors, SpinnerTypes } from '@ionic/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input() type: SpinnerTypes = 'crescent';

  @Input() color: PredefinedColors = 'primary';

  @Input() message = 'lbl.loading';

  @Input() size: 'small' | 'medium' | 'large' = 'small';

  constructor() {}

  ngOnInit() {}
}
